import MessageOptionItem from './MessageOptionItem';

export default MessageOptionItem;


// WEBPACK FOOTER //
// /src/components/mailThread/compose/messageHandler/messageOptionItem/index.js